
const UNSEEN_KEY  = (category) => `unseen_orders_${category}`;
const SEENFOR_KEY = (category) => `seen_orders_${category}`; 


const PENDING_STATUSES = {
  medicine: ['awaiting_bill'],         
  prescription: ['pending', 'awaiting_bill'],
  diagnostic: ['new'],
  package: ['Pending'],
  nursing: ['pending'],
};

const readSet = (key) => {
  try {
    return new Set(JSON.parse(localStorage.getItem(key) || "[]"));
  } catch {
    return new Set();
  }
};

const writeSet = (key, set, category) => {
  localStorage.setItem(key, JSON.stringify([...set]));
  window.dispatchEvent(new CustomEvent("unseen-orders-changed", { detail: { category } }));
};

export const isPendingStatus = (category, status) => {
  const list = PENDING_STATUSES[category] || [];
  return list.includes(status);
};

export const getUnseenCount = (category) => readSet(UNSEEN_KEY(category)).size;

export const isOrderUnseen = (category, orderId) => readSet(UNSEEN_KEY(category)).has(orderId);

// orders: [{ id: 'ORD123', status: 'awaiting_bill' }, ...]
export const registerFetchedOrders = (category, orders = []) => {
  const seenForever = readSet(SEENFOR_KEY(category));
  const unseen = readSet(UNSEEN_KEY(category));
  let changed = false;

  orders.forEach(({ id, status }) => {
    if (!id) return;
    const pending = isPendingStatus(category, status);

    if (pending && !seenForever.has(id) && !unseen.has(id)) {
      unseen.add(id);
      changed = true;
    }

    // If it's no longer pending (bill generated, delivered, etc.), stop highlighting it.
    if (!pending && unseen.has(id)) {
      unseen.delete(id);
      changed = true;
    }
  });

  if (changed) writeSet(UNSEEN_KEY(category), unseen, category);
};


// Marks it seen PERMANENTLY — it will never be highlighted again, even after re-login.
export const markOrderSeen = (category, orderId) => {
  if (!orderId) return;
  const unseen = readSet(UNSEEN_KEY(category));
  const seenForever = readSet(SEENFOR_KEY(category));
  let changed = false;

  if (unseen.delete(orderId)) changed = true;
  if (!seenForever.has(orderId)) {
    seenForever.add(orderId);
    changed = true;
  }

  if (changed) {
    localStorage.setItem(UNSEEN_KEY(category), JSON.stringify([...unseen]));
    localStorage.setItem(SEENFOR_KEY(category), JSON.stringify([...seenForever]));
    window.dispatchEvent(new CustomEvent("unseen-orders-changed", { detail: { category } }));
  }
};

// For a real-time WS "order created" event — only flags it if it's created in a pending state.
export const addUnseenOrder = (category, orderId, status) => {
  if (!orderId) return;
  if (!isPendingStatus(category, status)) return; // don't highlight non-pending creations

  const seenForever = readSet(SEENFOR_KEY(category));
  if (seenForever.has(orderId)) return; // already opened before, never re-highlight

  const unseen = readSet(UNSEEN_KEY(category));
  if (!unseen.has(orderId)) {
    unseen.add(orderId);
    writeSet(UNSEEN_KEY(category), unseen, category);
  }
};